var CRcarrierServiceEnabled = true;
document.addEventListener('crPickupActivated', function (e) { 

  cartForm = document.querySelector('#cart');
  //if (!cartForm) return;

  let isHandling = false;

  cartForm.addEventListener('submit', async (e) => {
    // Only intercept when the submit is for checkout
    const submitter = e.submitter; // modern browsers
    const isCheckout =
      (submitter && (submitter.name === 'checkout' || submitter.value === 'checkout')) ||
      // fallback if we can't detect submitter reliably
      true;
    console.log(submitter.name)
    if (!isCheckout) return;
    if (isHandling) return;

    e.preventDefault();
    isHandling = true;

    try {
      const cart = await storePickup.getCartItems();
      console.log(cart);

      // If your addLineProperty expects a cart + value:
      await storePickup.addLineProperty(cart, 'pickup');

      // Submit the cart form after your async call is done
      //cartForm.submit();
    } catch (err) {
      console.error('Failed to set line property before checkout:', err);

      // Decide what to do on failure:
      // 1) allow checkout anyway:
      //cartForm.submit();
      // 2) or block and show a message instead (replace with your UI)
      // alert('Please try again. Could not update cart.');
    } finally {
      isHandling = false;
    }
  });
})